import React from 'react';
import first from 'lodash.first';
import { clientPoint } from 'd3-selection';
import detectIt from 'detect-it';

import { HitboxRect } from 'components/data-visualization/LineChart/Hitbox';

const noop = (): any => {}; // eslint-disable-line @typescript-eslint/no-empty-function

const handleEvent = (x: any): any => {
  return function (evt: any, fn: any): any {
    const [clientX] = clientPoint(
      evt.target,
      'touches' in evt ? first(evt.touches) : evt
    );
    fn(new Date(x.invert(clientX)).valueOf());
  };
};

const Hitbox: React.FC<any> = (props) => {
  const {
    handleMouseHover = noop,
    handleMouseClick = noop,
    handleDragChange = noop,
    size,
    x = noop,
  } = props;
  const eventHandler = handleEvent(x);
  const { hasTouch, hasMouse } = detectIt;

  return (
    <HitboxRect
      {...size}
      onTouchStart={(): any => hasTouch && handleDragChange(true)}
      onTouchEnd={(): any => hasTouch && handleDragChange(false)}
      onTouchMove={(evt: any): any =>
        hasTouch && eventHandler(evt, handleMouseClick)
      }
      onMouseMove={(evt: any): any =>
        hasMouse && eventHandler(evt, handleMouseHover)
      } // set the temporary selected period to the hovered period
      onClick={(evt: any): any => eventHandler(evt, handleMouseClick)} // set the permanent selected period
      onMouseLeave={(): any => hasMouse && handleMouseHover(null)} // restore the clicked period (or rather, clear the temporary period)
    />
  );
};

export default Hitbox;
